var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as types from './types';
import * as statuses from '../../states';
var initialState = {
    status: statuses.IDLE,
    data: [],
    error: null,
};
export default function mailsReducer(state, action) {
    if (state === void 0) { state = initialState; }
    var type = action.type, payload = action.payload;
    switch (type) {
        case types.FETCH_MAILS_REQUEST:
            return __assign(__assign({}, state), { status: statuses.IDLE });
        case types.FETCH_MAILS_FAILED:
            return __assign(__assign({}, state), { status: statuses.FAIL, error: payload });
        case types.FETCH_MAILS_SUCCEEDED:
            return __assign(__assign({}, state), { status: statuses.SUCCESS, data: payload });
        case types.VALIDATE_MAIL_REQUEST:
            if (!(typeof payload === 'number'))
                return;
            return __assign(__assign({}, state), { data: state.data.map(function (item) { return ((item.id === payload)
                    ? __assign(__assign({}, item), { validation: statuses.LOADING }) : item); }) });
        case types.VALIDATE_MAIL_FAILED:
            if (!payload || typeof payload === 'number')
                return;
            return __assign(__assign({}, state), { data: state.data.map(function (item) { return ((item.id === payload.id)
                    ? __assign(__assign({}, item), { validation: statuses.FAIL, error: payload.error }) : item); }) });
        case types.VALIDATE_MAIL_SUCCEEDED:
            if (!(typeof payload === 'number'))
                return;
            return __assign(__assign({}, state), { data: state.data.map(function (item) { return ((item.id === payload)
                    ? __assign(__assign({}, item), { validation: statuses.SUCCESS, valider: true }) : item); }) });
        case types.VALIDATE_MODIFIED_MAIL_SUCCEEDED:
            if (!(typeof payload === 'number'))
                return;
            return __assign(__assign({}, state), { data: state.data.map(function (item) { return ((item.id === payload)
                    ? __assign(__assign({}, item), { validation: statuses.SUCCESS, status: 'verification', valider: false }) : item); }) });
        default:
            return state;
    }
}
